
import React from 'react';
import ClassAssembly  from 'views/ClassAssembly2A';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;